export const MOCK_SENSOR_ID = 100245;
export const MOCK_SENSOR_ID_2 = 445210;
export const MOCK_SENSOR_ID_3 = 344865;

export const MOCK_CAPTEUR = {
  sensor_id: MOCK_SENSOR_ID,
  sensor_name: 'Capteur Mock 1',
};

export const MOCK_CAPTEUR_2 = {
  sensor_id: MOCK_SENSOR_ID_2,
  sensor_name: 'Capteur Mock 2',
};

export const MOCK_CAPTEUR_3 = {
  sensor_id: MOCK_SENSOR_ID_3,
  sensor_name: 'Capteur Mock 3',
};

// Capteur mock -1 : positions 1, 2, 3
export const MOCK_SENSOR_DATA = [
  // --- position 1 ---
  {
    pk_test: 1001,
    time_unix: 1777708800,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 1,
    value: 12.4,
    calc_value: 12.4,
  },
  {
    pk_test: 1002,
    time_unix: 1777712400,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 1,
    value: 13.1,
    calc_value: 13.1,
  },
  {
    pk_test: 1003,
    time_unix: 1777716000,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 1,
    value: 11.8,
    calc_value: 11.8,
  },
  {
    pk_test: 1004,
    time_unix: 1777719600,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 1,
    value: 14.2,
    calc_value: 14.0,
  },
  {
    pk_test: 1005,
    time_unix: 1777723200,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 1,
    value: 12.9,
    calc_value: 12.9,
  },
  ...Array.from({ length: 100 }, (_, index) => {
    const offset = index + 6;
    const baseValue = 11.5 + (index % 12) * 0.35;
    return {
      pk_test: 1000 + offset,
      time_unix: 1777723200 + index * 3600,
      sensor_id: MOCK_SENSOR_ID,
      position_in_sensor: 1,
      value: Number(baseValue.toFixed(1)),
      calc_value: Number((baseValue + (index % 4 === 0 ? 0.2 : 0)).toFixed(1)),
    };
  }),
  // --- position 2 ---
  {
    pk_test: 2001,
    time_unix: 1777708800,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 2,
    value: 22.1,
    calc_value: 22.1,
  },
  {
    pk_test: 2002,
    time_unix: 1777712400,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 2,
    value: 23.4,
    calc_value: 23.4,
  },
  {
    pk_test: 2003,
    time_unix: 1777716000,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 2,
    value: 21.7,
    calc_value: 21.5,
  },
  {
    pk_test: 2004,
    time_unix: 1777719600,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 2,
    value: 24.0,
    calc_value: 23.8,
  },
  {
    pk_test: 2005,
    time_unix: 1777723200,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 2,
    value: 22.8,
    calc_value: 22.8,
  },
  ...Array.from({ length: 100 }, (_, index) => {
    const offset = index + 6;
    const baseValue = 21.0 + (index % 12) * 0.4;
    return {
      pk_test: 2000 + offset,
      time_unix: 1777723200 + index * 3600,
      sensor_id: MOCK_SENSOR_ID,
      position_in_sensor: 2,
      value: Number(baseValue.toFixed(1)),
      calc_value: Number((baseValue + (index % 3 === 0 ? 0.3 : 0)).toFixed(1)),
    };
  }),
  // --- position 3 ---
  {
    pk_test: 3001,
    time_unix: 1777708800,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 3,
    value: 5.2,
    calc_value: 5.2,
  },
  {
    pk_test: 3002,
    time_unix: 1777712400,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 3,
    value: 5.8,
    calc_value: 5.8,
  },
  {
    pk_test: 3003,
    time_unix: 1777716000,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 3,
    value: 4.9,
    calc_value: 4.9,
  },
  {
    pk_test: 3004,
    time_unix: 1777719600,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 3,
    value: 6.1,
    calc_value: 6.0,
  },
  {
    pk_test: 3005,
    time_unix: 1777723200,
    sensor_id: MOCK_SENSOR_ID,
    position_in_sensor: 3,
    value: 5.5,
    calc_value: 5.5,
  },
  ...Array.from({ length: 100 }, (_, index) => {
    const offset = index + 6;
    const baseValue = 4.8 + (index % 12) * 0.15;
    return {
      pk_test: 3000 + offset,
      time_unix: 1777723200 + index * 3600,
      sensor_id: MOCK_SENSOR_ID,
      position_in_sensor: 3,
      value: Number(baseValue.toFixed(1)),
      calc_value: Number((baseValue + (index % 5 === 0 ? 0.1 : 0)).toFixed(1)),
    };
  }),
];

// Capteur mock -2 : position 1 uniquement, timestamps similaires
export const MOCK_SENSOR_DATA_2 = [
  {
    pk_test: 4001,
    time_unix: 1777708800,
    sensor_id: MOCK_SENSOR_ID_2,
    position_in_sensor: 1,
    value: 8.3,
    calc_value: 8.3,
  },
  {
    pk_test: 4002,
    time_unix: 1777712400,
    sensor_id: MOCK_SENSOR_ID_2,
    position_in_sensor: 1,
    value: 9.0,
    calc_value: 9.0,
  },
  {
    pk_test: 4003,
    time_unix: 1777716000,
    sensor_id: MOCK_SENSOR_ID_2,
    position_in_sensor: 1,
    value: 7.6,
    calc_value: 7.5,
  },
  {
    pk_test: 4004,
    time_unix: 1777719600,
    sensor_id: MOCK_SENSOR_ID_2,
    position_in_sensor: 1,
    value: 9.4,
    calc_value: 9.4,
  },
  {
    pk_test: 4005,
    time_unix: 1777723200,
    sensor_id: MOCK_SENSOR_ID_2,
    position_in_sensor: 1,
    value: 8.7,
    calc_value: 8.7,
  },
  ...Array.from({ length: 100 }, (_, index) => {
    const offset = index + 6;
    const baseValue = 7.5 + (index % 10) * 0.25;
    return {
      pk_test: 4000 + offset,
      time_unix: 1777723200 + index * 3600,
      sensor_id: MOCK_SENSOR_ID_2,
      position_in_sensor: 1,
      value: Number(baseValue.toFixed(1)),
      calc_value: Number((baseValue + (index % 6 === 0 ? 0.15 : 0)).toFixed(1)),
    };
  }),
];

// Capteur mock -3 : positions 1 et 2, timestamps similaires
export const MOCK_SENSOR_DATA_3 = [
  // --- position 1 ---
  {
    pk_test: 5001,
    time_unix: 1777708800,
    sensor_id: MOCK_SENSOR_ID_3,
    position_in_sensor: 1,
    value: 30.5,
    calc_value: 30.5,
  },
  {
    pk_test: 5002,
    time_unix: 1777712400,
    sensor_id: MOCK_SENSOR_ID_3,
    position_in_sensor: 1,
    value: 31.2,
    calc_value: 31.2,
  },
  {
    pk_test: 5003,
    time_unix: 1777716000,
    sensor_id: MOCK_SENSOR_ID_3,
    position_in_sensor: 1,
    value: 29.8,
    calc_value: 29.6,
  },
  {
    pk_test: 5004,
    time_unix: 1777719600,
    sensor_id: MOCK_SENSOR_ID_3,
    position_in_sensor: 1,
    value: 32.0,
    calc_value: 31.9,
  },
  {
    pk_test: 5005,
    time_unix: 1777723200,
    sensor_id: MOCK_SENSOR_ID_3,
    position_in_sensor: 1,
    value: 30.9,
    calc_value: 30.9,
  },
  ...Array.from({ length: 100 }, (_, index) => {
    const offset = index + 6;
    const baseValue = 29.0 + (index % 12) * 0.45;
    return {
      pk_test: 5000 + offset,
      time_unix: 1777723200 + index * 3600,
      sensor_id: MOCK_SENSOR_ID_3,
      position_in_sensor: 1,
      value: Number(baseValue.toFixed(1)),
      calc_value: Number((baseValue + (index % 4 === 0 ? 0.25 : 0)).toFixed(1)),
    };
  }),
  // --- position 2 ---
  {
    pk_test: 6001,
    time_unix: 1777708800,
    sensor_id: MOCK_SENSOR_ID_3,
    position_in_sensor: 2,
    value: 18.0,
    calc_value: 18.0,
  },
  {
    pk_test: 6002,
    time_unix: 1777712400,
    sensor_id: MOCK_SENSOR_ID_3,
    position_in_sensor: 2,
    value: 18.7,
    calc_value: 18.7,
  },
  {
    pk_test: 6003,
    time_unix: 1777716000,
    sensor_id: MOCK_SENSOR_ID_3,
    position_in_sensor: 2,
    value: 17.5,
    calc_value: 17.4,
  },
  {
    pk_test: 6004,
    time_unix: 1777719600,
    sensor_id: MOCK_SENSOR_ID_3,
    position_in_sensor: 2,
    value: 19.1,
    calc_value: 19.0,
  },
  {
    pk_test: 6005,
    time_unix: 1777723200,
    sensor_id: MOCK_SENSOR_ID_3,
    position_in_sensor: 2,
    value: 18.4,
    calc_value: 18.4,
  },
  ...Array.from({ length: 100 }, (_, index) => {
    const offset = index + 6;
    const baseValue = 17.0 + (index % 12) * 0.3;
    return {
      pk_test: 6000 + offset,
      time_unix: 1777723200 + index * 3600,
      sensor_id: MOCK_SENSOR_ID_3,
      position_in_sensor: 2,
      value: Number(baseValue.toFixed(1)),
      calc_value: Number((baseValue + (index % 3 === 0 ? 0.2 : 0)).toFixed(1)),
    };
  }),
];

export const isMockSensorId = (sensorId) => {
  const numericId = Number(sensorId);
  return (
    numericId === MOCK_SENSOR_ID ||
    numericId === MOCK_SENSOR_ID_2 ||
    numericId === MOCK_SENSOR_ID_3
  );
};

export const mapSensorRows = (rows) =>
  rows.map((row, index) => ({
    ...row,
    id: row.pk_test ?? index,
    _dirty: false,
  }));

const toTs = (value) => {
  if (typeof value === 'number') return value;
  const parsed = Math.floor(new Date(value ?? 0).getTime() / 1000);
  return Number.isFinite(parsed) ? parsed : 0;
};

const getLatestMockHistoryEntry = (sensorId, pkTest) => {
  const sensorHistory = MOCK_SENSOR_HISTORY_MAP[Number(sensorId)] ?? {};
  const entries = sensorHistory[Number(pkTest)] ?? [];
  if (!entries.length) return null;

  return entries.reduce((latest, entry) =>
    toTs(entry.modification_date) > toTs(latest.modification_date)
      ? entry
      : latest
  );
};

const syncMockRowWithLatestHistory = (row) => {
  const latestEntry = getLatestMockHistoryEntry(row.sensor_id, row.pk_test);
  if (!latestEntry) return row;

  return {
    ...row,
    time_unix: latestEntry.new_time_unix ?? row.time_unix,
    value: latestEntry.new_value ?? row.value,
    calc_value: latestEntry.new_calc_value ?? row.calc_value,
  };
};

export const mapMockRows = (rows) =>
  rows.map((row) => ({
    ...syncMockRowWithLatestHistory(row),
    id: row.pk_test,
    _dirty: false,
  }));

const buildMockHistoryEntry = ({
  id,
  user_id,
  user_name,
  sensor_id,
  pk_test,
  position_in_sensor,
  modification_date,
  old_time_unix,
  new_time_unix,
  old_value,
  new_value,
  old_calc_value,
  new_calc_value,
  update_type,
}) => ({
  id,
  user_id,
  user_name,
  sensor_id,
  pk_test,
  position_in_sensor,
  modification_date,
  old_time_unix,
  new_time_unix,
  old_value,
  new_value,
  old_calc_value,
  new_calc_value,
  update_type,
});

export const MOCK_SENSOR_HISTORY_MAP = {
  [MOCK_SENSOR_ID]: {
    1001: [
      buildMockHistoryEntry({
        id: 2,
        user_id: 11,
        user_name: 'Alice Martin',
        sensor_id: MOCK_SENSOR_ID,
        pk_test: 1001,
        position_in_sensor: 1,
        modification_date: 1777730400,
        old_time_unix: 1777708800,
        new_time_unix: null,
        old_value: 12.4,
        new_value: null,
        old_calc_value: 12.4,
        new_calc_value: null,
        update_type: 'Delete',
      }),
      buildMockHistoryEntry({
        id: 1,
        user_id: 11,
        user_name: 'Alice Martin',
        sensor_id: MOCK_SENSOR_ID,
        pk_test: 1001,
        position_in_sensor: 1,
        modification_date: 1777816800,
        old_time_unix: null,
        new_time_unix: 1777708800,
        old_value: null,
        new_value: 12.4,
        old_calc_value: null,
        new_calc_value: 12.4,
        update_type: 'Restore',
      }),
    ],
    1002: [
      buildMockHistoryEntry({
        id: 3,
        user_id: 12,
        user_name: 'Marc Dupont',
        sensor_id: MOCK_SENSOR_ID,
        pk_test: 1002,
        position_in_sensor: 1,
        modification_date: 1777753200,
        old_time_unix: 1777712400,
        new_time_unix: 1777712400,
        old_value: 13.1,
        new_value: 13.5,
        old_calc_value: 13.1,
        new_calc_value: 13.5,
        update_type: 'Edit',
      }),
    ],
    2001: [
      buildMockHistoryEntry({
        id: 4,
        user_id: 14,
        user_name: 'Sofia Leroy',
        sensor_id: MOCK_SENSOR_ID,
        pk_test: 2001,
        position_in_sensor: 2,
        modification_date: 1777839600,
        old_time_unix: null,
        new_time_unix: 1777708800,
        old_value: null,
        new_value: 22.1,
        old_calc_value: null,
        new_calc_value: 22.1,
        update_type: 'Added',
      }),
    ],
  },
  [MOCK_SENSOR_ID_2]: {
    4001: [
      buildMockHistoryEntry({
        id: 6,
        user_id: 21,
        user_name: 'Nina Bernard',
        sensor_id: MOCK_SENSOR_ID_2,
        pk_test: 4001,
        position_in_sensor: 1,
        modification_date: 1777740000,
        old_time_unix: 1777708800,
        new_time_unix: null,
        old_value: 8.3,
        new_value: null,
        old_calc_value: 8.3,
        new_calc_value: null,
        update_type: 'Delete',
      }),
      buildMockHistoryEntry({
        id: 5,
        user_id: 21,
        user_name: 'Nina Bernard',
        sensor_id: MOCK_SENSOR_ID_2,
        pk_test: 4001,
        position_in_sensor: 1,
        modification_date: 1777846800,
        old_time_unix: null,
        new_time_unix: 1777708800,
        old_value: null,
        new_value: 8.3,
        old_calc_value: null,
        new_calc_value: 8.3,
        update_type: 'Restore',
      }),
    ],
    4002: [
      buildMockHistoryEntry({
        id: 7,
        user_id: 22,
        user_name: 'Nina Bernard',
        sensor_id: MOCK_SENSOR_ID_2,
        pk_test: 4002,
        position_in_sensor: 1,
        modification_date: 1777764000,
        old_time_unix: 1777712400,
        new_time_unix: 1777712400,
        old_value: 9.0,
        new_value: 9.2,
        old_calc_value: 9.0,
        new_calc_value: 9.2,
        update_type: 'Edit',
      }),
    ],
  },
  [MOCK_SENSOR_ID_3]: {
    5001: [
      buildMockHistoryEntry({
        id: 8,
        user_id: 31,
        user_name: 'Paul Garnier',
        sensor_id: MOCK_SENSOR_ID_3,
        pk_test: 5001,
        position_in_sensor: 1,
        modification_date: 1777747200,
        old_time_unix: 1777708800,
        new_time_unix: 1777708800,
        old_value: 30.5,
        new_value: 30.9,
        old_calc_value: 30.5,
        new_calc_value: 30.8,
        update_type: 'Edit',
      }),
    ],
    6001: [
      buildMockHistoryEntry({
        id: 9,
        user_id: 32,
        user_name: 'Paul Garnier',
        sensor_id: MOCK_SENSOR_ID_3,
        pk_test: 6001,
        position_in_sensor: 2,
        modification_date: 1777850400,
        old_time_unix: null,
        new_time_unix: 1777708800,
        old_value: null,
        new_value: 18.0,
        old_calc_value: null,
        new_calc_value: 18.0,
        update_type: 'Added',
      }),
      buildMockHistoryEntry({
        id: 10,
        user_id: 32,
        user_name: 'Paul Garnier',
        sensor_id: MOCK_SENSOR_ID_3,
        pk_test: 6001,
        position_in_sensor: 2,
        modification_date: 1777940400,
        old_time_unix: 1777708800,
        new_time_unix: 1777708800,
        old_value: 18.0,
        new_value: 18.0,
        old_calc_value: 18.0,
        new_calc_value: 18.0,
        update_type: 'Delete',
      }),
    ],
  },
};

export const getMockSensorHistory = (sensorIds = []) => {
  const normalizedIds = sensorIds
    .map((sensorId) => Number(sensorId))
    .filter((sensorId) => Number.isFinite(sensorId));

  return normalizedIds.flatMap((sensorId) => {
    const sensorHistory = MOCK_SENSOR_HISTORY_MAP[sensorId] ?? {};
    return Object.values(sensorHistory).flat();
  });
};
